import getProfileData from '../../api/Profile/getProfileData.api';
import {
	GET_PROFILE_SUCCESS,
	GET_PROFILE_FAIL,
	EDIT_PROFILE_SUCCESS,
	EDIT_PROFILE_FAIL,
} from './types';
import firebase from '../../lib/firebase.prod';
import saveProfile from '../../api/Profile/saveProfile.api';

export const getProfile = () => {
	return async (dispatch, getState) => {
		var currentUserId = firebase.auth().currentUser?.uid;
		try {
			console.log('getProfile is the try');
			getProfileData(currentUserId, (returned) => {
				console.log('getProfile returned', returned);
				dispatch(getProfileSuccess(returned));
			});
		} catch (error) {
			console.log('getProfile is the catch');
			dispatch(getProfileFail(error));
		}
	};
};

export const editProfile = (
	profileType,
	fullName,
	email,
	phoneNumber,
	companyName,
	uid,
	file,
	fileCompany
) => {
	return async (dispatch) => {
		try {
			saveProfile(
				profileType,
				fullName,
				email,
				phoneNumber,
				companyName,
				uid,
				file,
				fileCompany
			).then(() => dispatch(editProfileSuccess()));
		} catch (error) {
			dispatch(editProfileFail(error));
		}
	};
};

export const getProfileSuccess = (payload) => ({
	type: GET_PROFILE_SUCCESS,
	payload,
});

export const getProfileFail = (payload) => ({
	type: GET_PROFILE_FAIL,
	payload,
});

export const editProfileSuccess = (payload) => ({
	type: EDIT_PROFILE_SUCCESS,
	payload,
});

export const editProfileFail = (payload) => ({
	type: EDIT_PROFILE_FAIL,
	payload,
});
